// Small AI Studio pieces used on other dashboard pages:
//  - AIStudioBanner: the "generate from a few words" box on the home screen
//  - AIGeneratingCards: templates being generated, shown first in My Projects
//  - AICreateCard: the "Generate with AI" card on the Create page

import React, { useContext, useState } from "react";
import Card from "@mui/material/Card";
import AuthContext from "../context/userAuth.context";
import { useAIJobs, RUNNING } from "./AIJobsContext";
import { prefillAIStudio } from "./AIStudio";
import { useAIAccess, openAIStudio } from "./AIAccess";

export function AIStudioBanner() {
  const { setDivName } = useContext(AuthContext);
  const access = useAIAccess();
  const [keyword, setKeyword] = useState("");
  const go = () => {
    if (access.locked || access.studioUrl) return openAIStudio(access, setDivName, keyword.trim());
    prefillAIStudio(keyword.trim());
    setDivName("AI Studio");
  };
  // Hidden for customers who do not have AI Studio (when admins chose "hide").
  if (!access.show) return null;
  return (
    <div className="ais-banner">
      <div className="ais-banner-bg" />
      <div className="ais-banner-text">
        <span className="ais-pill"><span className="material-icons">auto_awesome</span> New &middot; AI Studio</span>
        <div className="ais-banner-h">Turn a few words into an animated video template</div>
      </div>
      <div className="ais-banner-input">
        <input
          value={keyword}
          maxLength={120}
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && go()}
          placeholder="What is your video about?"
        />
        <button onClick={go}>
          <span className="material-icons">auto_awesome</span> Generate
        </button>
      </div>
    </div>
  );
}

export function AIGeneratingCards() {
  const { jobs, openPanel } = useAIJobs();
  const running = jobs.filter((j) => RUNNING.includes(j.status));
  if (!running.length) return null;
  return running.map((j) => {
    const img = j.previews && j.previews.filter(Boolean).slice(-1)[0];
    return (
      <Card key={"ai" + j.id} sx={{ width: 345, maxWidth: 345 }} className="ais-gen-card" onClick={() => openPanel(j.id)}>
        <div className="ais-gen-media">
          {img ? <img src={img} alt="" /> : <span className="material-icons ais-spin-slow">auto_awesome</span>}
          <span className="ais-gen-badge"><span className="ais-spinner light" /> Generating {Math.max(2, j.progress || 2)}%</span>
        </div>
        <div className="ais-gen-info">
          <div className="ais-tile-title">{j.keyword}</div>
          <div className="ais-mini-bar"><span style={{ width: Math.max(4, j.progress || 4) + "%" }} /></div>
        </div>
      </Card>
    );
  });
}

export function AICreateCard() {
  const { setDivName } = useContext(AuthContext);
  const access = useAIAccess();
  if (!access.show) return null;
  return (
    <button className="ais-create-wide" onClick={() => openAIStudio(access, setDivName)}>
      <span className="ais-create-icon"><span className="material-icons">auto_awesome</span></span>
      <span className="ais-create-text">
        <strong>Generate with AI</strong>
        <span>Type an idea and get a ready-made animated template with scenes, texts and a talking presenter.</span>
      </span>
      <span className="ais-create-go">Try AI Studio <span className="material-icons">arrow_forward</span></span>
    </button>
  );
}
